import { pacientesStore, calendarLog, usersCollection } from './firebase';
import { parseDesc } from '../hooks/useEventos';

/**
 * Analiza la colección `calendarlog` al cargar el login:
 *  - De cada registro extrae los campos `create`, `peticion` y `solicitado`.
 *  - De `AppointmentType` (el texto completo de la descripción del evento,
 *    con formato "Clave=Valor|Clave2=Valor2|...") extrae puntualmente la
 *    clave "Unidad Hospitalaroa".
 *  - Hace un cruce (merge) entre `solicitado` y el campo `Nombre` de la
 *    colección de usuarios: si hay coincidencia, clasifica el registro
 *    como "usuario"; si no la hay, lo clasifica como "medico" (se asume
 *    que `solicitado` trae el nombre de un médico, no de un usuario del
 *    sistema).
 *
 * Es una función de solo lectura (no escribe nada en Firestore) — el
 * resultado se muestra únicamente por console.log, para su análisis.
 */
export const analizarCalendarLog = async () => {
  try {
    console.log("hola")
    // ── Catálogo de usuarios (para el merge por nombre) ──
    const usersSnap = await pacientesStore.collection(usersCollection).get();
    const nombresUsuarios = new Set();
    usersSnap.forEach((doc) => {
      const nombre = doc.data()?.Nombre;
      if (nombre) nombresUsuarios.add(nombre.trim().toUpperCase());
    });
    console.log(usersSnap)

    // ── Recorrer calendarlog y armar el resultado ──
    const logSnap = await pacientesStore.collection(calendarLog).get();
    const resultado = [];

    logSnap.forEach((doc) => {
      const d = doc.data() || {};

      const fields = parseDesc(d.AppointmentType);
      const unidadHospitalaria =
        fields['Unidad Hospitalaroa'] || fields['Unidad Hospitalaria'] || null;

      const solicitado = d.solicitado || null;
      const tipoSolicitante = solicitado
        ? (nombresUsuarios.has(solicitado.trim().toUpperCase()) ? 'usuario' : 'medico')
        : null;

      resultado.push({
        id: doc.id,
        create: d.create || null,
        peticion: d.peticion || null,
        solicitado,
        tipoSolicitante,
        unidadHospitalaria,
      });
    });

    console.log(`[analizarCalendarLog] ${resultado.length} registros de calendarlog procesados:`);
    console.log(resultado);

    return resultado;
  } catch (err) {
    console.error('[analizarCalendarLog] Error al analizar calendarlog:', err);
    return [];
  }
};